import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/** Time in seconds to trigger refresh loop */
export const useFlagappKeycloakTriggerRefreshSeconds = (): number => useINTERNALFlag('app-keycloak-trigger-refresh-seconds', {localDefault: 240});
/** Time in seconds to trigger refresh loop */
export const FlagappKeycloakTriggerRefreshSeconds = (props: PropsNoName) => <INTERNALFlag name="app-keycloak-trigger-refresh-seconds" localDefault={240} {...props}/>
